import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2, Euro, ShoppingBag, Users2, Package2 } from 'lucide-react';
import { useAdminOverviewStats } from '@/hooks/useAdminCatalog';

export default function AdminOverview() {
  const { isLoading, stats } = useAdminOverviewStats();

  if (isLoading) {
    return <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-zinc-400" /></div>;
  }
  if (!stats) return null;

  const topRevenue = Object.entries(stats.revenueByAddon)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-zinc-900">Panoramica Catalogo</h1>
        <p className="text-sm text-zinc-500">Riepilogo dei prodotti DryConfig in vendita e revenue dal marketplace.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Kpi label="Prodotti attivi" value={`${stats.activeAddons} / ${stats.totalAddons}`} icon={<Package2 className="h-5 w-5 text-blue-600" />} />
        <Kpi label="Acquisti pagati" value={String(stats.paidEntitlements)} icon={<ShoppingBag className="h-5 w-5 text-emerald-600" />} />
        <Kpi label="Org con almeno 1 addon" value={String(stats.totalOrgsWithAtLeastOneAddon)} icon={<Users2 className="h-5 w-5 text-purple-600" />} />
        <Kpi label="Revenue marketplace" value={`€${stats.totalRevenue.toLocaleString('it-IT')}`} icon={<Euro className="h-5 w-5 text-amber-600" />} />
      </div>

      {topRevenue.length > 0 && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Revenue per prodotto (top 5)</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2">
              {topRevenue.map(([slug, amount]) => (
                <li key={slug} className="flex items-center justify-between text-sm">
                  <span className="text-zinc-700 font-mono text-xs">{slug}</span>
                  <span className="font-semibold text-zinc-900">€{amount.toLocaleString('it-IT')}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      )}

      <Card className="bg-zinc-50 border-zinc-200">
        <CardContent className="p-4 text-sm text-zinc-600">
          <strong className="text-zinc-900">Come muoverti qui:</strong>
          <ul className="mt-2 space-y-1 list-disc list-inside">
            <li><strong>Listini</strong>: cataloghi prezzi per brand. Da qui carichi nuove versioni annuali via Excel.</li>
            <li><strong>Stratigrafie</strong>: stratigrafie vendibili per brand. Puoi promuovere strat custom B4T a stratigrafie pubbliche.</li>
            <li><strong>Entitlements</strong>: chi ha comprato cosa, dove sono finiti i soldi, audit per refund/customer support.</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}

function Kpi({ label, value, icon }: { label: string; value: string; icon: React.ReactNode }) {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-2">{icon}<span className="text-xs text-zinc-500 uppercase tracking-wide">{label}</span></div>
        <div className="text-2xl font-bold text-zinc-900">{value}</div>
      </CardContent>
    </Card>
  );
}
